// ** Initial State
const initialState = {
  allData: [],
  allPackages: [],
  data: [],
  total: 1,
  params: {},
  currentUser: null,
  selectedUser: null,
  selectedPackage: null,
  bookEdit: false,
  openModel: false,
  token: JSON.parse(localStorage.getItem("accessToken"))
}

// console.log('sssssssssssss', selectedUser)

const packagesPurchase = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_PACKAGES':
      return { ...state, allPackages: [...action.data] }
    case 'GET_PACKAGE_DATA':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'GET_USER':
      console.log(action)
      return { ...state, selectedUser: action.selectedUser }
    case 'ADD_USER':
    return {...state, allData: action.data}
    case 'DELETE_PACKAGE':
      console.log(action.data)
      return { ...state, allPackages: action.data }
    case 'EDITPACKAGE':
      return {...state, selectedPackage: action.data}
    case "PACKAGE_PURCHASE":
      return {...state, selectedPackage: action.data, openModel: true}
    case 'CLOSE_MODEL':
      return {...state, openModel: false}
    default:
      return { ...state }
  }
}
export default packagesPurchase
